import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useRef, useState, useCallback } from "react";
import useFileManager from "../Components/FileManager/useFileManager/useFileManagerManualReport";
import useFolderFilesManager from "../Components/FileManager/useFileManager/Files";
import { useLang } from '../Hooks';
// [FIX] direct imports — lazy() + Suspense causes React #321 with Chakra v2 + React 19
import FoldersManager from "../Components/FileManager/Folders/FoldersManualReport";
import ViewManager from "../Components/FileManager/View/ViewManualReport";
import ViewFileModal from "../Components/FileManager/Modals/ViewFile";

// [FIX] hooks split into inner component — hooks cannot be called after a conditional return
const FileManagerManualReportContent = ({ ContractData, Tab, texts }) => {
  const {
    Folders, FolderData, OnRefetchFolders, OnRefetchFolder,
    IsFoldersLoading,
    IsFolderContentsLoading,
    State, SelectedFolder, OnSubmit, OnChange, OnSelectFolder,
    OpenFolders, OnToggleFolder,
  } = useFileManager({ ContractData, Tab });

  const {
    OnSubmit: OnSubmitFile,
  } = useFolderFilesManager();

  const handleFileSubmit = async (form) => {
    const success = await OnSubmitFile(form);
    if (success) {
      OnRefetchFolder();
    }
    return success;
  };

  const [sidebarWidth, setSidebarWidth] = useState(280);
  const isResizing = useRef(false);

  const handleMouseMove = useCallback((e) => {
    if (isResizing.current) {
      const newWidth = e.clientX;
      if (newWidth > 240 && newWidth < window.innerWidth / 2) {
        setSidebarWidth(newWidth);
      }
    }
  }, []);

  const handleMouseUp = useCallback(() => {
    isResizing.current = false;
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
  }, [handleMouseMove]);

  const handleMouseDown = (e) => {
    e.preventDefault();
    isResizing.current = true;
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const pageHeight = { base: "auto", md: "calc(100dvh - 7rem)" };

  return (
    <Box>
      <Flex gap={1.5} h={pageHeight}>
        <Box w={`${sidebarWidth}px`} minW="240px">
          <FoldersManager
            OnRefetch={OnRefetchFolders}
            OnSelect={OnSelectFolder}
            OnChange={OnChange}
            OnToggleFolder={OnToggleFolder}
            OpenFolders={OpenFolders}
            Selected={SelectedFolder}
            Props={{
              Folders,
              IsFoldersLoading: IsFoldersLoading,
            }}
            texts={texts}
          />
        </Box>
        <Box
          w="5px"
          cursor="col-resize"
          onMouseDown={handleMouseDown}
          borderRadius="full"
          sx={{
            bg: 'var(--resizer-bg)',
            _hover: { bg: 'var(--resizer-hover-bg)' }
          }}
        />
        <Box flex="1">
          <ViewManager
            SelectedFolder={SelectedFolder}
            OnChange={OnChange}
            OnSelect={OnSelectFolder}
            OnRefetch={OnRefetchFolder}
            OnSubmitFolder={OnSubmit}
            OnSubmitFile={handleFileSubmit}
            Height={pageHeight}
            Props={{
              FolderData,
              AllFolders: Folders,
              IsFoldersLoading: IsFolderContentsLoading,
            }}
            texts={texts}
          />
        </Box>
      </Flex>
      <ViewFileModal
        OnClose={() => OnChange("Reset")}
        IsOpen={State.IsOpen && State.Tab === "ViewFile"}
        Selected={State.File}
        texts={texts}
      />
    </Box>
  );
};

const FileManagerManualReport = ({ ContractData, Tab }) => {
  const { texts } = useLang();

  if (!ContractData) {
    return (
      <Flex justify="center" align="center" h="200px">
        <Spinner />
      </Flex>
    );
  }

  return (
    <FileManagerManualReportContent
      ContractData={ContractData}
      Tab={Tab}
      texts={texts}
    />
  );
};

export default FileManagerManualReport;
